/** Stopwatch-style elapsed time from an ISO start timestamp. */
export function formatDurationSeconds(secs: number): string {
  const safe = Math.max(Math.floor(secs), 0);
  const hours = Math.floor(safe / 3600);
  const mins = Math.floor((safe % 3600) / 60);
  const rem = safe % 60;
  if (hours > 0) {
    return `${hours}:${String(mins).padStart(2, "0")}:${String(rem).padStart(2, "0")}`;
  }
  return `${mins}:${String(rem).padStart(2, "0")}`;
}

export function formatElapsed(fromIso: string, now: number): string {
  const secs = Math.max(Math.floor((now - new Date(fromIso).getTime()) / 1000), 0);
  return formatDurationSeconds(secs);
}

/** Worked time, with finished breaks removed and an open pause frozen. */
export function formatWorkedElapsed(
  startedAt: string,
  now: number,
  breakSeconds: number,
  pausedAt?: string | null,
): string {
  const start = new Date(startedAt).getTime();
  const end = pausedAt ? new Date(pausedAt).getTime() : now;
  const secs = Math.floor((end - start) / 1000) - breakSeconds;
  return formatDurationSeconds(secs);
}
